import moment from "moment"
import React from "react"
import { Checkbox, Col, ControlLabel, FormControl, FormGroup, Radio, Row } from "react-bootstrap"
import { customerFieldsObject } from "../../../lib/utils"

export default function({ data }) {

  const renderInputText = ({ type, placeHolder, min, max }) => {

    let htmlType = 'text'
    switch(type) {
      case customerFieldsObject.DATE:
      case customerFieldsObject.DATE_OF_BIRTH:
        htmlType = 'date'
        break

      case customerFieldsObject.DATETIME:
        htmlType = 'datetime-local'
        break

      case customerFieldsObject.NUMBER:
        htmlType = 'number'
        break

      case customerFieldsObject.EMAIL:
        htmlType = 'email'
        break

      default: break
    }

    if(type === customerFieldsObject.DATE) {
      min = min ? moment(min).format('YYYY-MM-DD') : ''
      max = max ? moment(max).format('YYYY-MM-DD') : ''
    }
    else if(type === customerFieldsObject.DATETIME) {
      min = min ? moment(min).format('YYYY-MM-DDTHH:mm:ss') : ''
      max = max ? moment(max).format('YYYY-MM-DDTHH:mm:ss') : ''
    }

    return <FormControl
      type={ htmlType }
      placeholder={ placeHolder }
      min={ min ? min : '' }
      max={ max ? max : '' }
      className='w-250'
    />
  }

  const renderSelect = ({ options }) => {

    const htmlOptions = []
    for(let k in options) {
      htmlOptions.push(<option key={ k } value={ k }>{ options[k] }</option>)
    }

    return <FormControl componentClass="select" className='w-250'>
      <option value=""></option>
      { htmlOptions }
    </FormControl>
  }

  const renderRadio = ({ options, name }) => {
    const htmlOptions = []
    for(let k in options) {
      htmlOptions.push(<label key={ k }>
        <Radio name={ name } value={ k } inline>{ options[k] }</Radio> &nbsp; &nbsp; </label>
      )
    }
  
    return <FormGroup>
      { htmlOptions }
    </FormGroup>
  }

  const renderCheckbox = ({ placeHolder }) => 
    <FormGroup><Checkbox inline>{ placeHolder }</Checkbox></FormGroup>

  const renderField = data => {

    switch(data.type) {
      case customerFieldsObject.TEXT:
      case customerFieldsObject.EMAIL:
      case customerFieldsObject.DATE:
      case customerFieldsObject.DATETIME:
      case customerFieldsObject.DATE_OF_BIRTH:
      case customerFieldsObject.NUMBER:
        return renderInputText(data)

      case customerFieldsObject.CHECKBOX:
        return renderCheckbox(data)

      case customerFieldsObject.RADIO:
        return renderRadio(data)

      case customerFieldsObject.SELECT:
        return renderSelect(data)

      default: return null
    }
  }

  const extraInfo = data => data.regex ? <em>&nbsp; &nbsp; Regex: { data.regex }</em> : ''

  return (
    <FormGroup controlId='previewId'>
      <Row>
        <Col xsOffset={2}>
          <ControlLabel>{ data.label }</ControlLabel>
          { extraInfo(data) }
          { renderField(data) }
        </Col>
      </Row>
    </FormGroup>
  )
}



// WEBPACK FOOTER //
// ./src/components/Settings/Customers/RenderCustomerItem.js